import React from 'react';
import { Result } from 'antd';


const Exceptions = (props) => {
    const statusCode = props.match.params.statusCode;
    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                height: "100vh"
            }}
        >
            {
                statusCode == "404" ?
                    <Result
                        status="404"
                        title="404"
                        subTitle="Sorry, the page you visited does not exist."
                    />
                    :
                    statusCode == "500" ?
                        <Result
                            status="500"
                            title="500"
                            subTitle="Something went wrong. Please try again after some time."
                        />
                        :
                        <Result
                            status="404"
                            title="404"
                            subTitle="Sorry, the page you visited does not exist."
                        />

            }
        </div>
    )
};


export { Exceptions };